(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-accessories"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const accessoriesBlock = document.querySelector(".product-accessories");
    const wrapper = document.querySelector(".product-accessories-wrapper");
    const addAccessoriesToCartBtn = document.querySelector(".add-accessories-to-cart-button");
    const dataScript = document.querySelector("#ProductAccessoriesData");

    if (!accessoriesBlock || !wrapper || !addAccessoriesToCartBtn) return;

    let accessoriesData = null;

    if (dataScript) {
      try {
        accessoriesData = JSON.parse(dataScript.textContent);
      } catch (error) {
        console.error("Erro ao ler dados dos acessórios:", error);
      }
    }

    const checkboxes = wrapper.querySelectorAll(".product-item-checkmark");
    const productItems = Array.from(wrapper.querySelectorAll(".product-item"));

    function normalizeText(text) {
      return String(text || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    }

    function isSizeOptionName(optionName) {
      const normalized = normalizeText(optionName);

      return (
        normalized.includes("tamanho") ||
        normalized.includes("size") ||
        normalized.includes("numero") ||
        normalized.includes("numeração") ||
        normalized.includes("numeracao")
      );
    }

    function getMainVariantId() {
      const variantInputs = Array.from(
        document.querySelectorAll(
          'form[action*="/cart/add"] input[name="id"], product-form input[name="id"], input[name="id"]'
        )
      );

      const mainVariantInput = variantInputs.find(function (input) {
        return !input.closest(".product-accessories");
      });

      if (mainVariantInput && mainVariantInput.value) {
        return mainVariantInput.value;
      }

      return addAccessoriesToCartBtn.dataset.mainVariantId;
    }

    function getMainVariant() {
      if (!accessoriesData || !accessoriesData.mainProduct) return null;

      const mainVariantId = String(getMainVariantId());

      return accessoriesData.mainProduct.variants.find(function (variant) {
        return String(variant.id) === mainVariantId;
      });
    }

    function getMainSelectedSize() {
      if (!accessoriesData || !accessoriesData.mainProduct) return null;

      const mainVariant = getMainVariant();

      if (!mainVariant) return null;

      const mainOptions = accessoriesData.mainProduct.options || [];

      let sizeOptionIndex = mainOptions.findIndex(function (optionName) {
        return isSizeOptionName(optionName);
      });

      if (sizeOptionIndex === -1 && mainOptions.length === 1) {
        sizeOptionIndex = 0;
      }

      if (sizeOptionIndex === -1) return null;

      return mainVariant.options[sizeOptionIndex];
    }

    function getAccessoryProductByItem(productItem) {
      if (!accessoriesData || !accessoriesData.accessories) return null;

      const itemIndex = productItems.indexOf(productItem);

      if (itemIndex === -1) return null;

      return accessoriesData.accessories[itemIndex] || null;
    }

    function findAccessoryVariantByMainSize(productItem) {
      const selectedSize = getMainSelectedSize();
      const accessoryProduct = getAccessoryProductByItem(productItem);

      if (!accessoryProduct || !accessoryProduct.variants || !accessoryProduct.variants.length) {
        return null;
      }

      if (!selectedSize) {
        const fallbackVariantId = productItem.dataset.productVariantId;

        return (
          accessoryProduct.variants.find(function (variant) {
            return String(variant.id) === String(fallbackVariantId);
          }) || accessoryProduct.variants[0]
        );
      }

      const selectedSizeNormalized = normalizeText(selectedSize);
      const accessoryOptions = accessoryProduct.options || [];

      let accessorySizeOptionIndex = accessoryOptions.findIndex(function (optionName) {
        return isSizeOptionName(optionName);
      });

      if (accessorySizeOptionIndex === -1 && accessoryOptions.length === 1) {
        accessorySizeOptionIndex = 0;
      }

      let matchedVariant = null;

      if (accessorySizeOptionIndex !== -1) {
        matchedVariant = accessoryProduct.variants.find(function (variant) {
          return (
            variant.available &&
            normalizeText(variant.options[accessorySizeOptionIndex]) === selectedSizeNormalized
          );
        });

        if (!matchedVariant) {
          matchedVariant = accessoryProduct.variants.find(function (variant) {
            return normalizeText(variant.options[accessorySizeOptionIndex]) === selectedSizeNormalized;
          });
        }
      }

      if (!matchedVariant) {
        matchedVariant = accessoryProduct.variants.find(function (variant) {
          return (
            variant.available &&
            variant.options.some(function (optionValue) {
              return normalizeText(optionValue) === selectedSizeNormalized;
            })
          );
        });
      }

      if (!matchedVariant) {
        matchedVariant = accessoryProduct.variants.find(function (variant) {
          return variant.available;
        });
      }

      return matchedVariant || accessoryProduct.variants[0];
    }

    function syncCheckedItems() {
      checkboxes.forEach(function (checkbox) {
        const productItem = checkbox.closest(".product-item");

        if (!productItem) return;

        productItem.dataset.checked = checkbox.checked ? "true" : "false";
      });
    }

    function updateAccessoryTotals() {
        syncCheckedItems();

        let totalPrice = 0;
        let totalComparePrice = 0;

        const mainVariant = getMainVariant();

        if (mainVariant) {
            totalPrice += Number(mainVariant.price || 0);
            totalComparePrice += Number(mainVariant.compare_at_price || mainVariant.price || 0);
        }

        wrapper.querySelectorAll('.product-item[data-checked="true"]').forEach(function (item) {
            const accessoryVariant = findAccessoryVariantByMainSize(item);

            if (accessoryVariant) {
            totalPrice += Number(accessoryVariant.price || 0);
            totalComparePrice += Number(accessoryVariant.compare_at_price || accessoryVariant.price || 0);
            return;
            }

            totalPrice += Number(item.dataset.price || 0);
            totalComparePrice += Number(item.dataset.compareAtPrice || item.dataset.price || 0);
        });

        const totalSelectedEl = accessoriesBlock.querySelector(".total-selected");
        const totalCompareSelectedEl = accessoriesBlock.querySelector(".total-compare-selected");

        if (totalSelectedEl && typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
            totalSelectedEl.textContent = Shopify.formatMoney(totalPrice, window.money_format);
        }

        if (totalCompareSelectedEl && typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
            totalCompareSelectedEl.textContent = Shopify.formatMoney(totalComparePrice, window.money_format);

            if (totalPrice >= totalComparePrice) {
            totalCompareSelectedEl.classList.add("hidden");
            } else {
            totalCompareSelectedEl.classList.remove("hidden");
            }
        }
    }

    function replaceElementHTML(selector, html) {
      const currentElement = document.querySelector(selector);

      if (!currentElement || !html) return false;

      const newDocument = new DOMParser().parseFromString(html, "text/html");
      const newElement = newDocument.querySelector(selector);

      if (!newElement) return false;

      currentElement.innerHTML = newElement.innerHTML;

      return true;
    }

    function fetchAndReplaceSection(sectionId, selectors) {
      const cartUrl = window.Shopify.routes.root + "cart";

      return fetch(cartUrl + "?section_id=" + sectionId, {
        method: "GET",
        headers: {
          Accept: "text/html",
        },
      })
        .then(function (response) {
          if (!response.ok) return false;
          return response.text();
        })
        .then(function (html) {
          if (!html) return false;

          let replaced = false;

          selectors.forEach(function (selector) {
            if (replaceElementHTML(selector, html)) {
              replaced = true;
            }
          });

          return replaced;
        })
        .catch(function () {
          return false;
        });
    }

    function refreshCartDrawerHTML() {
      const drawerSelectors = [
        "cart-drawer",
        "#CartDrawer",
        ".cart-drawer",
        "[data-cart-drawer]",
        ".halo-cart-sidebar",
        "#halo-cart-sidebar",
        ".halo-sidebar-cart",
        "#halo-sidebar-cart"
      ];

      const sectionIds = [
        "cart-drawer",
        "halo-cart-sidebar",
        "cart-sidebar",
        "main-cart-items"
      ];

      return sectionIds.reduce(function (promise, sectionId) {
        return promise.then(function (alreadyUpdated) {
          if (alreadyUpdated) return true;

          return fetchAndReplaceSection(sectionId, drawerSelectors);
        });
      }, Promise.resolve(false));
    }

    function refreshCartIconBubble() {
      const bubbleSelectors = [
        "#cart-icon-bubble",
        ".cart-count-bubble",
        "[data-cart-count-bubble]",
        "[data-cart-count]",
        ".cart-count",
        ".header__cart-count"
      ];

      const sectionIds = [
        "cart-icon-bubble",
        "header",
        "main-header"
      ];

      return sectionIds.reduce(function (promise, sectionId) {
        return promise.then(function (alreadyUpdated) {
          if (alreadyUpdated) return true;

          return fetchAndReplaceSection(sectionId, bubbleSelectors);
        });
      }, Promise.resolve(false));
    }

    function openCartDrawer() {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:open"));
      document.dispatchEvent(new CustomEvent("cart:drawer:open"));
      document.dispatchEvent(new CustomEvent("drawer:open"));
      document.dispatchEvent(new CustomEvent("theme:cart:open"));
      document.dispatchEvent(new CustomEvent("cart-drawer:open"));

      const cartDrawer =
        document.querySelector("cart-drawer") ||
        document.querySelector("cart-notification") ||
        document.querySelector(".cart-drawer") ||
        document.querySelector("#CartDrawer") ||
        document.querySelector("[data-cart-drawer]") ||
        document.querySelector(".halo-cart-sidebar") ||
        document.querySelector("#halo-cart-sidebar") ||
        document.querySelector(".halo-sidebar-cart") ||
        document.querySelector("#halo-sidebar-cart");

      if (cartDrawer) {
        if (typeof cartDrawer.open === "function") {
          cartDrawer.open();
          return;
        }

        cartDrawer.classList.add("active", "is-open", "open", "animate", "show");
        cartDrawer.setAttribute("open", "");
        cartDrawer.setAttribute("aria-hidden", "false");
      }

      const cartDrawerTrigger =
        document.querySelector("[data-cart-sidebar]") ||
        document.querySelector("[data-cart-drawer-toggle]") ||
        document.querySelector("[data-cart-drawer-open]") ||
        document.querySelector('[aria-controls="CartDrawer"]') ||
        document.querySelector('[aria-controls="halo-cart-sidebar"]') ||
        document.querySelector('[aria-controls="halo-sidebar-cart"]') ||
        document.querySelector('a[href="/cart"]') ||
        document.querySelector('a[href*="/cart"]');

      if (cartDrawerTrigger) {
        cartDrawerTrigger.click();
      }
    }

    function refreshCartAndOpenDrawer() {
      fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (typeof window.updateCart === "function") {
            window.updateCart(cart);
          }

          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: {
                cart: cart,
              },
            })
          );

          document.dispatchEvent(
            new CustomEvent("cart:change", {
              detail: {
                cart: cart,
              },
            })
          );

          return Promise.all([
            refreshCartDrawerHTML(),
            refreshCartIconBubble(),
          ]);
        })
        .then(function () {
          setTimeout(openCartDrawer, 150);
        })
        .catch(function (error) {
          console.error("Erro ao atualizar o carrinho lateral:", error);
          setTimeout(openCartDrawer, 150);
        });
    }

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener("change", updateAccessoryTotals);
    });

    document.addEventListener("change", function (event) {
      if (
        event.target.matches('select[name="id"]') ||
        event.target.matches('input[name="id"]') ||
        event.target.closest("[data-product-option-change]") ||
        event.target.closest(".product-form__input") ||
        event.target.closest(".productView-variants")
      ) {
        setTimeout(updateAccessoryTotals, 100);
      }
    });

    updateAccessoryTotals();

    addAccessoriesToCartBtn.addEventListener("click", function () {
      syncCheckedItems();

      const items = [];
      const mainVariantId = getMainVariantId();

      if (mainVariantId) {
        items.push({
          id: Number(mainVariantId),
          quantity: 1,
        });
      }

      wrapper.querySelectorAll('.product-item[data-checked="true"]').forEach(function (item) {
        const accessoryVariant = findAccessoryVariantByMainSize(item);
        const variantId = accessoryVariant ? accessoryVariant.id : item.dataset.productVariantId;

        if (!variantId) return;

        items.push({
          id: Number(variantId),
          quantity: 1,
        });
      });

      if (!items.length) return;

      addAccessoriesToCartBtn.disabled = true;
      addAccessoriesToCartBtn.classList.add("loading");

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: items,
        }),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }

          return response.json();
        })
        .then(function () {
          refreshCartAndOpenDrawer();
        })
        .catch(function (error) {
          console.error("Erro ao adicionar compre junto:", error);
        })
        .finally(function () {
          addAccessoriesToCartBtn.disabled = false;
          addAccessoriesToCartBtn.classList.remove("loading");
        });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
